<div class="package-filters">
  <div class="flex mb-4">
    <lum-ui-input
      placeholder="Search..."
      class="w-50 mr-2"
      [debounceTime]="500"
      (inputChangeEvent)="searchEvent.emit($event)"
    ></lum-ui-input>
    <lum-package-create></lum-package-create>
  </div>
</div>
